import { useMemo } from 'react';

import { createAuthenticatedAxiosInstance } from 'src/utils/axios';

import { useAuthContext } from 'src/auth/hooks';


export function useAuthenticatedAxios() {
    const { user } = useAuthContext(); // This now automatically returns virtual user when active
    
    return useMemo(() => createAuthenticatedAxiosInstance(user?.accessToken), [user?.accessToken]);
}